import { render } from "./CrewStat.vue?vue&type=template&id=d63ba782"
import script from "./CrewStat.vue?vue&type=script&lang=js"
export * from "./CrewStat.vue?vue&type=script&lang=js"

import "./CrewStat.vue?vue&type=style&index=0&id=d63ba782&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/CrewStat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d63ba782"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d63ba782', __exports__)) {
    api.reload('d63ba782', __exports__)
  }
  
  module.hot.accept("./CrewStat.vue?vue&type=template&id=d63ba782", () => {
    api.rerender('d63ba782', render)
  })

}


export default __exports__